"use strict";

import { invariant } from '@autoguru/utilities';
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const fleetCompaniesList = [{
  name: 'Ampol',
  slug: 'ampol',
  id: '1'
}];
const fleetCompanyContext = /*#__PURE__*/createContext(null);
export const useFleetCompany = () => {
  const contextValue = useContext(fleetCompanyContext);
  !(contextValue !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Please have a <FleetCompanyProvilder /> set in your tree') : invariant(false) : void 0;
  return contextValue;
};
export const FleetCompanyProvider = ({
  slug,
  children
}) => {
  const fleetCompanyContextValue = useMemo(() => fleetCompaniesList.find(({
    slug: companySlug
  }) => slug === companySlug), [slug]);
  return /*#__PURE__*/_jsx(fleetCompanyContext.Provider, {
    value: fleetCompanyContextValue,
    children: children
  });
};